import { Component } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-textarea',
	template: `
		<vp-textarea
			[autocomplete]="props['autocomplete']"
			[disabled]="props.disabled"
			[formControl]="formControl"
			[hasError]="showError"
			[initialValue]="formControl.value"
			[isOptional]="props['optional']"
			[isValid]="formControl.valid"
			[name]="field.id"
			[placeholder]="props.placeholder"
			[readonly]="props.readonly"
			[rows]="props['rows']"
			[textareaId]="field.id"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class TextareaComponent extends FieldType<FieldTypeConfig> {}
